/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';
import { TimeSlotListParams, TimeSlot } from '~core/models/time-slot.models';

@Injectable()
export class TimeSlotService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(timeSliceId: string): Observable<TimeSlot> {
    return this._httpClient.get<TimeSlot>(
      `${this._apiConstantsService.timeSlotsUrl}/${timeSliceId}`
    );
  }

  list(params?: TimeSlotListParams): Observable<Pagination<TimeSlot>> {
    return this._httpClient.get<Pagination<TimeSlot>>(
      this._apiConstantsService.timeSlotsUrl,
      {
        params: {
          ...params,
          details: ''
        } as Record<string, any>
      }
    );
  }

  getDownloadUrl(startAtRange: string): string {
    return `${this._apiConstantsService.timeSlotsUrl}/download?startAt=${startAtRange}`;
  }
}
